import PropTypes from 'prop-types';
import compact from 'lodash/compact';

const FormattedAddress = ({ address }) => {
  const { street_address: streetAddress, suburb, postcode, country } = address;

  return `${streetAddress.join(', ')}, ${compact([suburb, postcode]).join(' ')}, ${country}`;
};

FormattedAddress.propTypes = {
  address: PropTypes.shape({
    street_address: PropTypes.arrayOf(PropTypes.string).isRequired,
    suburb: PropTypes.string.isRequired,
    postcode: PropTypes.string,
    country: PropTypes.string.isRequired,
  }).isRequired,
};

export default FormattedAddress;
